<template>
    <ModalFormCard :action="action" class="modal-default" :submittedCallback="submitted" v-bind="{ errors, saving }" :toast="toast">
        <template #title>{{ setting.title() }}</template>

        <input type="hidden" name="key" :value="setting.key" />
        <input type="hidden" name="belongs_id" :value="editingModel.modelId" />
        <input type="hidden" name="belongs_type" :value="editingModel.modelType" />

        <Input v-model:value="value.name" class="input-white" :label="setting.label() + ' name'" name="name" placeholder="New name" />

        <input name="color" :value="value.color" type="hidden" />

        <div class="grid grid-cols-12 gap-2 mt-4 flex-wrap" v-if="setting.me() == 'pipeline stage'">
            <button
                class="w-[30px] h-[30px] border flex items-center justify-center shrink-0"
                v-for="c in colors"
                type="button"
                @click="setColor(c)"
                :class="{
                    'border-green-500': value.color == c,
                    'border-grey-500': value.color != c,
                }"
            >
                <div class="w-5 h-5" :style="{ background: c }" />
            </button>
        </div>

        <div class="modal-buttons">
            <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2" name="published_at" value="1">
                {{ setting.title() }}
            </ButtonSaving>

            <button :disabled="saving" type="button" class="button-purple default" @click="$emit('close')">Cancel</button>
        </div>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import Setting from '~/models/setting.js'

export default {
    mixins: [Modal],

    data() {
        return {
            action: this.editingModel.id != undefined ? '/user-setting/' + this.editingModel.id : '/user-setting',
            value: {
                name: this.editingModel ? this.editingModel.name : '',
                color: this.editingModel ? this.editingModel.color : '',
            },
            colors: [
                '#422756',
                '#613681',
                '#8B4DB6',
                '#DAB5FF',

                '#14634F',
                '#008F6B',
                '#00B885',
                '#B2FFEA',

                '#1C8DB0',
                '#00D6EC',
                '#6BF0FF',
                '#C0F9FF',

                '#DC583C',
                '#FF9026',
                '#FFCD40',
                '#FFF3D2',

                '#000000',
                '#7C7C7C',
                '#939393',
                '#C9C9C9',
                '#E4E4E4',
            ],
        }
    },

    methods: {
        setColor(color) {
            this.value.color = color
        },

        submitted(res) {
            this.$authSanctum.getUser(true)
            this.$event.$emit('deal-stages-updated', res)
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },

    computed: {
        setting() {
            return new Setting(this.editingModel, {
                $vue: this,
            })
        },

        toast() {
            return this.$help.capitalizeFirstLetter(this.setting.me()) + (this.editingModel.id != undefined ? ' updated' : ' created')
        },
    },
}
</script>
